<template>
  <InformationDossierStep />
  <MissionStep v-if="meta.mission?.$status !== PropertyStatus.NotPresent && model?.typeDemande === 'Remboursement'" />
</template>

<script setup lang="ts">
  import { PropertyStatus } from '@/features/domaine/property-status'
  import { storeToRefs } from 'pinia'
  import { inject } from 'vue'
  import { DEMANDE_STORE } from '../../../shared'
  import InformationDossierStep from './sections/informationDossier/InformationDossierStep.vue'
  import MissionStep from './sections/mission/MissionStep.vue'

  const store = inject(DEMANDE_STORE)!.getStore<'MODEL_DR'>()
  const { model, meta } = storeToRefs(store)
</script>
